module.exports = __webpack_public_path__ + "img/quarter-fold.51bfa747.svg";